module.exports = __webpack_public_path__ + "static/media/news.f6f6dfaf.svg";